import { useContext } from 'react';
import { screenPopContext } from './providers';

export default function useScreenPop() {
    const context = useContext(screenPopContext);
    if (!context) throw new Error('useScreenPop must be used within a ScreenPopProvider');
    return context;
}
